import React from "react";
import { useTranslation } from "react-i18next";
// Components
import { ProtocolHeaderMainDiv, ProtocolHeaderDiv, ProtocolTitle } from "./styles";

const ProtocolHeader = ({ section }) => {
  const [t] = useTranslation("global");

  return (
    <ProtocolHeaderMainDiv>
      <ProtocolHeaderDiv>
        <ProtocolTitle width="220px" padding="0 0 0 110px">
          {t("prescriptions.tableProtocolText")}
        </ProtocolTitle>
        <ProtocolTitle width={section === "home" || section === "clinic" ? "110px" : "231px"} center>
          {t("prescriptions.tableDurationText")}
        </ProtocolTitle>
        <ProtocolTitle width="410px"></ProtocolTitle>
        <ProtocolTitle width="118px" center>
          {t("prescriptions.tableReportsText")}
        </ProtocolTitle>
      </ProtocolHeaderDiv>
    </ProtocolHeaderMainDiv>
  );
};

export default ProtocolHeader;
